import { createStore , combineReducers , applyMiddleware}   from 'redux';
import {thunk} from 'redux-thunk';
import userReducer from './Reducer/userReducer';
import chatReducer from './Reducer/chatReducer';

const rootReducers = combineReducers({userReducer,chatReducer}); 

export const Store = createStore(rootReducers , applyMiddleware(thunk));